import toast, {
    type ToastOptions as _ToastOptions,
    Toaster,
} from "react-hot-toast";

type ToastOptions = _ToastOptions;

const error = (error: Error | string, options?: ToastOptions) => {
    const message = typeof error === "string" ? error : error.message;
    toast.error(message, options);
};

const success = (message: string, options?: ToastOptions) => {
    toast.success(message, options);
};

const Provider = () => Toaster({ position: "bottom-center" });

export const ToastService = { error, success, Provider };
